import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import BeginYourApplicationPage from './BeginYourApplicationPage';
import { dataCaptureSelectors, redirectToInitialPage } from '../../store/dataCapture';
import { BEGIN_YOUR_APPLICATION_PAGE_INFO } from '../../utils/constants';

const BeginApplicationSection = ({ bankId, redirectToInitialPage, getBusinessData }) =>
  bankId ? (
    <BeginYourApplicationPage
      saveApplicationCompleteForm={redirectToInitialPage}
      getBusinessData={getBusinessData}
    />
  ) : (
    <span />
  );

BeginApplicationSection.propTypes = {
  bankId: PropTypes.bankId,
  saveApplicationCompleteForm: PropTypes.func.isRequired
};

const actionCreators = {
  redirectToInitialPage
};

const mapStateToProps = state => ({
  bankId: selectors.bankId(state),
  getBusinessData: dataCaptureSelectors.getBusinessData(state, BEGIN_YOUR_APPLICATION_PAGE_INFO)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BeginApplicationSection);
